"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIndexWebsocket = void 0;
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const CacheData_1 = require("./base/CacheData");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
class FIndexWebsocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.dataCache = new CacheData_1.CacheData(new Map(), new rxjs_1.BehaviorSubject(new Map()));
        this.pairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.fIndex, (type, param) => {
            return this.send(QuotationSocketMgr_1.SubscribeEventType.fIndex, param);
        });
    }
    handleData(pushData) {
        if (!pushData || pushData.length === 0) {
            return;
        }
        pushData.forEach((indexEle) => {
            const index = FIndexWebsocket.parsePushData(indexEle);
            this.dataCache.getCacheData().set(index.symbol, index);
        });
        this.dataCache.emit();
    }
    static parsePushData(index) {
        return {
            symbol: index.b + "/" + index.q,
            base: index.b || "",
            quote: index.q || "",
            index_price: index.ip || "",
            mark_price: index.mp || "",
            interest_margin: index.im || "",
            next_funding_rate: index.nfr || "",
            next_funding_time: String(index.nft) || "",
            update_time: index.t || 0,
        };
    }
    /**
     * 订阅交易所所有币对
     * @param exchange
     * key 为 exchange/base/quote
     */
    getFIndexObservableByEx(exchange) {
        const pairs = [{ market: exchange, base: "", quote: "" }];
        this.pairPoolMgr.addSubscribePair(pairs);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.dataCache.getDataSubject().subscribe((result) => {
                observer.next(result);
            }, (err) => {
                (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_ERROR, QuotationSocketMgr_1.QuotationSocketMgr.TAG, `getFIndexObservableByEx ${exchange} error ${JSON.stringify(err)}`);
            });
            observer.add(() => {
                this.pairPoolMgr.removeSubscribePair(pairs);
                subscription.unsubscribe();
            });
        });
    }
    getFIndexObservableByPair(exchange, base, quote) {
        this.pairPoolMgr.addSubscribePair([{ market: exchange, base: base, quote: quote }]);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.dataCache.getDataSubject().subscribe((result) => {
                const findResult = result.get(`${base}/${quote}`);
                if (findResult) {
                    observer.next(findResult);
                }
            }, (err) => { });
            observer.add(() => {
                subscription.unsubscribe();
                this.pairPoolMgr.removeSubscribePair([
                    {
                        market: exchange,
                        base: base,
                        quote: quote,
                    },
                ]);
            });
        });
    }
    getFIndexObservableBatch(pairInfoList) {
        this.pairPoolMgr.addSubscribePair(pairInfoList);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.dataCache.getDataSubject().subscribe((result) => {
                const filterResult = [];
                pairInfoList.forEach((pairInfo) => {
                    if (pairInfo.base && pairInfo.quote) {
                        const index = result.get(`${pairInfo.base}/${pairInfo.quote}`);
                        if (index) {
                            filterResult.push(index);
                        }
                    }
                });
                observer.next(filterResult);
            }, (error) => {
                (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_ERROR, QuotationSocketMgr_1.QuotationSocketMgr.TAG, `getFIndexObservableBatch error ${JSON.stringify(error)}`);
            });
            observer.add(() => {
                subscription.unsubscribe();
                this.pairPoolMgr.removeSubscribePair(pairInfoList);
            });
        });
    }
}
exports.FIndexWebsocket = FIndexWebsocket;
